
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 500 500","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M447.667 149.854c-.365-3.608-1.886-6.947-4.398-9.559L310.972 7.999c-.461-.398-1.123-.43-1.584-.791a16.4 16.4 0 00-11.477-4.699H117.492a66.157 66.157 0 00-46.83 19.414c-12.436 12.404-19.414 29.27-19.446 46.835v363.61c0 36.545 29.731 66.244 66.276 66.244h264.356a66.485 66.485 0 0046.834-19.414c12.404-12.436 19.414-29.27 19.414-46.83V152.037c0-.763-.328-1.457-.429-2.183zM315.804 60.126l75.735 75.337h-43.026c-4.302 0-8.536-.826-12.504-2.48-3.969-1.653-7.572-4.032-10.614-7.074a32.89 32.89 0 01-7.111-10.618 33.044 33.044 0 01-2.48-12.505v-42.66z","fill":"#C0C2FF"}})])
          )
        }
      }
    